import { proxy } from "valtio";
import Utils from "../util/Utils";

export const editStore = proxy({
subscript:0,
schind:0,
contract:{},
saveschedule:false,
savecharge:false,
routes:[],
pricingRec:{},
mrg:false,
list:[],
pkb:[],
rebate:[],
savedisable:true,
schedule:{
    por:"",
    pol:"",
    pod:"",
    fpod:"",
    cutoffpor:"",
    etdpol:"",
    etapod:"",
    etafpod:"",
    vesselname:"",
    voyage:"",
    carrier:"",
    transittime:"",
    coloader:"",
    stuffing_cutoff:""
},
getval:(k,d)=>{
    if(d[k]!=undefined && d[k].toString().length>0){
        return d[k]
    }else{
        return ""
    }
},
getvaldate:(k,d)=>{
    if(d[k]!=undefined && d[k].toString().length>0){
        return Utils.getCurrentDateString(new Date(d[k]))
    }else{
        return ""
    }
},
setlclSchedule:(data)=>{
    let s = editStore.schedule
    let gv = editStore.getval
    let gvd = editStore.getvaldate
    s.cutoffpor=gvd("cutoffpor",data)
    s.etapod=gvd("etapod",data) || gvd("ETA (POD)",data)
    s.etdpol=gvd("etdpol",data) || gvd("ETD (POL)",data)
    s.etafpod=gvd("etafpod",data)
    s.por=gv("por",data)
    s.pol=gv("pol",data)
    s.pod=gv("pod",data)
    s.fpod=gv("fpod",data)
    s.rep=gv("rep",data)
    s.vesselname=gv("VESSEL NAME",data)
    s.voyage=gv("VOYAGE",data)
    s.carrier=""
    s.transittime=gv("transitTime",data)
    s.coloader=gv("CO-LOADER",data)
    s.stuffing_cutoff=gv("STUFFING CUT OFF DATE",data)
},
setfclSchedule:(data)=>{
    let s = editStore.schedule
    let gv = editStore.getval
    let gvd = editStore.getvaldate
    s.cutoffpor=gvd("cutoffpor",data)
    s.etapod=gvd("etapod",data)
    s.etdpol=gvd("etdpol",data)
    s.etafpod=gvd("etafpod",data)
    s.por=gv("por",data)
    s.pol=gv("pol",data)
    s.pod=gv("pod",data)
    s.fpod=gv("fpod",data)
    s.rep=gv("rep",data)
    s.vesselname=gv("v1name",data)
    s.voyage=gv("s1voy",data)
    s.carrier=gv("cscac",data)
    s.transittime=gv("transitTime",data)
    s.coloader=""
    s.stuffing_cutoff=gv("STUFFING CUT OFF DATE",data)
}
})